export default __webpack_public_path__ + "static/media/deauville06.f39f795a.jpg";